<template>
    <div class="d-block">

        <div v-if="teamErrors.length" class="alert alert-danger">
            <ul class="mb-0">
                <li v-for="teamError in teamErrors">{{ teamError }}</li>
            </ul>
        </div>

        <!--Form Fields-->
        <div class="form-group"
        >
            <label>Team Name</label>
            <input class="form-control"
                   v-model="name"
                   required
            />


        </div>

        <!--Terms-->
        <div class="form-group"
        >
            <input
                type="checkbox"
                v-model="requires_password"
            />
            People will need to enter a password to join the team
        </div>


        <!--Form Fields-->
        <div
            class="form-group"
            v-if="requires_password"
        >
            <label>Password</label>
            <input
                class="form-control"
                type="password"
                v-model="password"/>


        </div>


        <button class="mt-3 btn btn-success" @click="saveTeam" type="button">Save Team</button>
    </div>
</template>

<script>


export default {
    name: "NewTeam",

    props: {
        registrationCategoryId: {
            type: Number,
            required: true,
        },

    },

    data() {
        return {
            name: '',
            requires_password: false,
            password: null,
            teamErrors: []
        }
    },
    methods: {
        saveTeam() {

            this.teamErrors = [];
            axios.post(`/api/internal/teams/add.json`, {
                name: this.name,
                requires_password: this.requires_password,
                password: this.password,
                registration_category_id: this.registrationCategoryId,
            })
                .then((res) => {
                    if (res.data.entity) {
                        this.name = "";
                        this.requires_password = false;
                        this.password = "";
                        this.$emit('created', res.data.entity);
                    } else {
                        let errors = [];
                        let keys = Object.keys(res.data.errors);
                        keys.forEach((key) => {
                            let errorObject = res.data.errors[key];
                            let errorObjectKeys = Object.keys(errorObject);
                            errorObjectKeys.forEach(objKey => {
                                errors.push(errorObject[errorObjectKeys]);
                            })
                        });
                        this.teamErrors = errors;
                    }
                })
        }


    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Teams/Form/Add.vue